import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><path d="M4.5 2.007a2.5 2.5 0 000 5c.446 0 .856-.14 1.218-.344l1.97 1.844-1.97 1.843a2.473 2.473 0 00-1.218-.343 2.5 2.5 0 102.5 2.5c0-.23-.036-.446-.094-.657L9.03 9.788l4.469 4.219H15v-1L6.906 5.163A2.46 2.46 0 007 4.507a2.5 2.5 0 00-2.5-2.5zm0 1.5a1 1 0 110 2 1 1 0 010-2zm9-.5L9.562 6.725l1.313 1.282 4.125-4v-1zm-9 8.5a1 1 0 110 2 1 1 0 010-2z" style={{
      isolation: "auto",
      mixBlendMode: "normal"
    }} color="#000" overflow="visible" fill="#474747" /></svg>;
}

export default SvgComponent;